<template>
    <v-navigation-drawer class="app-menu appmenubg" :dark="dark" :color="dark ? 'primary' : ''" overlay-color="#000" width="300" app fixed v-model="show" right :temporary="!permanent" :permanent="permanent">
        <div class="drawer-header">
            <div class=" d-flex justify-center align-center px-6 py-6" :style="statusBarOverlay ? `padding-top: ${statusBarInsetPx}px!important` : ''">
                <div class="logo-wrapper my-2 ">
                    <logo :white="dark" medium />
                </div>
                <!-- <v-btn v-if="phoneOnly || !isAuthed" large class="mb-1" icon @click.prevent="show=false">
                    <v-icon size="24">mdi-menu</v-icon>
                </v-btn> -->
            </div>
            
            <!-- <div v-if="isAuthed" class="d-flex align-center py-2 px-7">
                <div class="text-center">
                    <avatar :src="user.avatar" :size="50" :icon-size="35"/>
                </div>
                <div class="mr-2">
                    <div class="user-name mr-2" style="line-height: 1rem">{{user.name}}</div>
                    <v-btn dense small v-if="isAuthed" text @click="logoutDialog = true; show = false">تسجيل الخروج</v-btn>
                </div>
            </div> -->
        </div>
        <!-- <v-divider class="my-2" /> -->

        <v-list :dark="dark" nav class="px-4 py-0 transparent white--text">
            <template v-for="(item, i) in drawerRoutes">
                
                <!-- <v-divider class="mb-1" v-if="item.divider" :key="'d-' + i" /> -->

                <v-list-item v-if="!item.show || self[item.show]" v-haptic v-show="!item.pcOnly || pcOnly" color="white" :key="i" link :to="item.to" exact class="menu-list-item my-3 px-4 px-lg-5" v-ripple="phoneOnly" @click="openRoute(item.to)">
                    <v-list-item-icon class="me-4 my-auto">
                        <v-icon :class="activeRoute !== item.to.name ? 'menu-color' : ''">{{ activeRoute === item.to.name ? item.icon.replace('-outline', '') : item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title :class="activeRoute !== item.to.name ? 'menu-color' : ''" style="font-size: 0.95rem; line-height: 1.4rem">{{item.name}}</v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
            </template>
        </v-list>
        <v-divider class="my-5" />
        
        <div class="text-center">
            
            <div class="mt-2">
                <social-btns colored small />
            </div>

            <div v-if="!capRunning && !miniDerasaPlatform" class="store-badges d-flex align-center justify-center px-6 mt-2">
                <store-badge type="playstore" width="123px" />
                <store-badge type="appstore" width="95px" />
            </div>

            <div class="ltr-dir d-flex align-center justify-center mt-2">
                <div class="small-text primary--text text--lighten-4 ms-2">Powered By: </div>
                <a href="https://www.derasa.tech" :target="capRunning ? '_system' : '_blank'">
                    <img class="derasatech-logo" :src="asset('derasatech-logo/logo-white.png', 'img')" style="width: auto; height: 14px; opacity: 0.8"/>
                </a>
            </div>

            <div class="details-text menu-color">جميع الحقوق محفوظة © 2024</div>

        </div>

        <logout-dialog v-model="logoutDialog" />
    </v-navigation-drawer>
    
</template>

<script>
import GlobalMethods from '@/helpers/global-methods'
import GlobalComputed from '@/helpers/global-computed'
import drawerRoutes from '@/helpers/links'
import StoreBadge from '../default/store-badge'
import Avatar from '../default/avatar'
import SocialBtns from '../main/social-btns'
import LogoutDialog from '../default/dialogs/logout'

export default {
    name: 'app-menu',
    props: ['value'],
    data(){
        return {
            self: this,
            show: false,
            logoutDialog: false,
            dark: true,
        }
    },
    components: {
        Avatar,
        SocialBtns,
        LogoutDialog,
        StoreBadge,
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    computed: {
        activeRoute(){
            return this.$route.name;
        },
        drawerRoutes(){
            return this.isAuthed ? drawerRoutes.auth : drawerRoutes.guest;
        },
        permanent(){
            return this.pcOnly && this.isAuthed && !this.$route.meta.temporaryMenu;
        },
        showExams(){
            return !!this.appData.enable_gen_exm;
        },
        showWallet(){
            return !!this.appData.enable_wallet_system;
        },
        showCenterWallet(){
            return !!this.appData.enable_student_center_wallet_section && this.user && !!this.user.center_id;
        },
        showHonorPanel(){
            const place = this.appData.honor_panel_place;
            // Menu entry when separated page is enabled, or when home can deep-link to full list
            return place === 'separated' || place === 'home' || !place;
        },
        showWrongAnswers(){
            return !!this.appData.enable_wrong_answers_page;
        },
        showTeachers(){
            return !!this.appData.teachers_page;
        },
        ...GlobalComputed
    },
    methods: {
        openRoute(to){
            if (this.phoneOnly){
                this.show = false;
                /* window.setTimeout(()=>{
                    this.$router.push(to);
                }, 400); */
            }else{
                /* this.$router.push(to); */
            }
        },
        showWatermark(){
            this.watermarkOpacity += 0.01;
        },
        openProfile(){
            let isProfile = this.$route.name === 'profile' && this.$route.params.id == this.user.id;
            if (!isProfile){
                this.$router.push({name: 'profile', params: {id: this.user.id}});
            }
        },
        ...GlobalMethods
    },
    mounted(){
    
    }
}
</script>

<style lang="scss" scoped>
.app-menu{
    transition: all 0.35s ease, background-color 0s linear;
    @media(max-width: 960px){
        transition: all 0.25s ease-in-out, background-color 0s linear;
    }
    
    
    .v-list-item.menu-list-item{
        margin-bottom: 7px!important;
        border-radius: 5px!important;
        overflow: hidden;
        height: 38px;

        background-color: rgba(#000, 0.15);
        
    }

    .menu-color{
        // color: #a696cc!important;
        color: #d4d4d4!important;
    }
}
</style>